import ApiServices, { InstanceKeys } from "@/api/apexchat.api.services";
import { Import } from "@/api/endpoints";
import { createSlice } from "@reduxjs/toolkit";

export const importSlice = createSlice({
  name: "import",
  initialState: {
    selectedImport: {},
    mode: 1,
  },

  reducers: {
    setSelectedImportToState: (state, action) => {
      state.selectedImport = action.payload;
    },
    setImportMode: (state, action) => {
      state.mode = action.payload;
    },
  },
});

export const { setSelectedImportToState, setImportMode } = importSlice.actions;

export const getSelectedImport = (state) => {
  return state.import.selectedImport;
};

export const getImportMode = (state) => {
  return state.import.mode;
};

export const uploadImportedFile = (payload, params = "") => {
  let url = `${Import.upload}${params ? "?" : ""}${params}`;
  return ApiServices.postAttachements(url, payload, InstanceKeys.crmInstance);
};

export default importSlice.reducer;
